import React from "react";
import { observer } from "mobx-react";
import Swal from "../../shared/Swal";
import "./SwitchSite.scss";
import Select from "react-select";
import SwitchSiteStore from "./SwitchSiteStore";

const SwitchSite = observer(({ store }) => {
  return (
    <div className="switch-sites">
      <h2>Switch Site</h2>
      <section>
        <label className="for-select">
          <div>Select a site below to switch to it.</div>
          <br />
          <Select
            styles={{
              option: (provided) => ({
                ...provided,
                textAlign: "left",
              }),
            }}
            placeholder="Select site..."
            options={store.siteOptions}
            value={store.selectedSiteOption}
            isOptionDisabled={(option) => option.disabled}
            onChange={(option) => {
              store.selectedSiteOption = option;
              Swal.getConfirmButton().disabled = false;
            }}
          />
        </label>
      </section>
    </div>
  );
});

export default SwitchSite;

export function popupSwitchSite() {
  this.props.store.userMenuOpen = false;
  const store = new SwitchSiteStore();
  Swal.fire({
    html: (
      <div id="prefs">
        <SwitchSite store={store} />
      </div>
    ),
    showCancelButton: true,
    customClass: "prefs",
    confirmButtonText: "Switch to Site",
    reverseButtons: true,
    didOpen: () => (Swal.getConfirmButton().disabled = true),
  }).then((result) => {
    if (result.isConfirmed) {
      store.goToSelectedSite();
    }
  });
}
